import React, { useState, useEffect, useCallback } from 'react';
import { Share2, Link2, Twitter, Facebook, Check } from 'lucide-react';
import axios from 'axios';
import { API } from '@/api';
import { getLocalizedField } from '../../utils/localizedContent';


export default function ShareButton({ collectionId, lang, t }) {
  const [showMenu, setShowMenu] = useState(false);
  const [copied, setCopied] = useState(false);
  const [shareInfo, setShareInfo] = useState(null);

  const fetchShareInfo = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/collections/${collectionId}/share`);
      setShareInfo(data);
    } catch (err) {
      console.error(err);
    }
  }, [collectionId]);

  useEffect(() => {
    if (showMenu && !shareInfo) {
      fetchShareInfo();
    }
  }, [fetchShareInfo, showMenu, shareInfo]);

  const copyLink = async () => {
    if (shareInfo?.share_url) {
      await navigator.clipboard.writeText(shareInfo.share_url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const shareTwitter = () => {
    const text = getLocalizedField(shareInfo, 'share_text', lang, shareInfo?.share_text_en || shareInfo?.share_text_es || '');
    window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(shareInfo?.share_url)}`, '_blank');
  };

  const shareFacebook = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareInfo?.share_url)}`, '_blank');
  };

  return (
    <div className="relative">
      <button
        onClick={() => setShowMenu(!showMenu)}
        className="px-3 py-1.5 rounded-lg text-xs font-semibold bg-[#0D5E4A]/30 text-[#2D8B70] border border-[#2D8B70]/30 hover:bg-[#0D5E4A]/50 transition-all flex items-center gap-1"
        data-testid="share-btn"
      >
        <Share2 size={12} /> {t('collections.share')}
      </button>

      {showMenu && (
        <div className="absolute right-0 top-full mt-2 w-48 bg-[#0F1F1A] border border-[#C9A962]/20 rounded-xl shadow-xl overflow-hidden z-50">
          <button
            onClick={copyLink}
            className="w-full px-4 py-3 text-left text-sm flex items-center gap-3 text-[#A8B5AE] hover:bg-[#0D5E4A]/20 hover:text-[#F5F0E6] transition-colors"
            data-testid="copy-link-btn"
          >
            {copied ? <Check size={16} className="text-[#2D8B70]" /> : <Link2 size={16} />}
            {copied ? t('collections.link_copied') : t('collections.copy_link')}
          </button>
          <button
            onClick={shareTwitter}
            className="w-full px-4 py-3 text-left text-sm flex items-center gap-3 text-[#A8B5AE] hover:bg-[#0D5E4A]/20 hover:text-[#F5F0E6] transition-colors"
            data-testid="share-twitter-btn"
          >
            <Twitter size={16} /> Twitter / X
          </button>
          <button
            onClick={shareFacebook}
            className="w-full px-4 py-3 text-left text-sm flex items-center gap-3 text-[#A8B5AE] hover:bg-[#0D5E4A]/20 hover:text-[#F5F0E6] transition-colors"
            data-testid="share-facebook-btn"
          >
            <Facebook size={16} /> Facebook
          </button>
        </div>
      )}
    </div>
  );
}
